import styled from 'styled-components';

export const Container = styled.div`
	padding: 20px;
	background: #fff;
	border-radius: 8px;
`;

export const SeatsContainer = styled.div`
	margin: 24px 0;
	min-height: 500px;
`;

export const ModeSelector = styled.select`
	padding: 8px 12px;
	border: 1px solid #ddd;
	border-radius: 4px;
	background: white;
	font-size: 14px;
	cursor: pointer;
	margin-left: auto;

	&:hover {
		border-color: #999;
	}

	&:focus {
		outline: none;
		border-color: #666;
	}
`;

export const HeaderRow = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	margin: 0;
`;

export const ChannelDescription = styled.p`
	margin-top: 8px;
	color: #666;
`;

export const ButtonWrapper = styled.div`
	min-width: 100px;
`;

export const ChannelLinksSection = styled.div`
	padding: 20px;
	background: #f8f9fa;
	border-radius: 8px;
`;

export const ChannelLinksTitle = styled.h3`
	font-size: 18px;
	font-weight: 600;
	margin: 0;
	color: #333;
`;

export const ChannelList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

export const ChannelItem = styled.div`
	display: flex;
	align-items: center;
	padding: 12px;
	background: white;
	border: 1px solid #e1e4e8;
	border-radius: 6px;
`;

export const ChannelInfo = styled.div`
	flex: 1;
	display: flex;
	flex-direction: column;
	gap: 4px;
`;

export const ChannelName = styled.span`
	font-weight: 600;
	color: #333;
	font-size: 14px;
`;

export const ChannelKey = styled.span`
	font-size: 12px;
	color: #666;
	font-family: monospace;
`;

export const ChannelLink = styled.div`
	flex: 2;
	padding: 8px 12px;
	background: #f6f8fa;
	border: 1px solid #d1d5da;
	border-radius: 4px;
	font-family: monospace;
	font-size: 12px;
	color: #666;
	word-break: break-all;
	margin: 0 12px;
`;

export const CopyButton = styled.button<{ copied?: boolean }>`
	padding: 8px 16px;
	background: ${(props) => (props.copied ? props.theme.colors.green : props.theme.colors.blue)};
	color: white;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: all 0.2s ease;
	min-width: 80px;

	&:hover {
		background: ${(props) => (props.copied ? props.theme.colors.green2 : props.theme.colors.blue2)};
		transform: translateY(-1px);
	}

	&:active {
		transform: translateY(0);
	}
`;

export const NoChannelsMessage = styled.p`
	color: #666;
	font-style: italic;
	text-align: center;
	padding: 20px;
`;
